const state = () => ({
  activate_editor: '',
  is_open_editor: true,
  catch_iframe_selected_data: {},
  catch_iframe_carousel_data: {},
  send_iframe_post_message_data: {},
  reset_editor_data: false,
  sdk_carousel_new_id: 'carousel-1',
  carousel_previous_data: {},
})

const mutations = {
  CATCH_IFRAME_SELECTED_DATA(state, data) {
    state.catch_iframe_selected_data = data
  },
  CATCH_IFRAME_CAROUSEL_DATA(state, data) {
    state.catch_iframe_carousel_data = data
  },
  SEND_IFRAME_POST_MESSAGE_DATA(state, data) {
    state.send_iframe_post_message_data = data
  },
  SET_EDITOR(state, component_name) {
    state.activate_editor = component_name
  },
  SET_IS_OPEN_EDITOR(state, is_open_editor) {
    state.is_open_editor = is_open_editor
  },
  RESET_EDITOR_DATA(state, new_value) {
    state.reset_editor_data = new_value
  },
  SDK_CAROUSEL_NEW_ID(state, new_val) {
    state.sdk_carousel_new_id = new_val
  },
  CAROUSEL_PREVIOUS_DATA(state, new_val) {
    state.carousel_previous_data = new_val
  },
  RESET_STATE() {}, // reset store/optimize state
}

const getters = {
  activate_editor: (state) => state.activate_editor,
  is_open_editor: (state) => state.is_open_editor,
  catch_iframe_selected_data: (state) => state.catch_iframe_selected_data,
  catch_iframe_carousel_data: (state) => state.catch_iframe_carousel_data,
  send_iframe_post_message_data: (state) => state.send_iframe_post_message_data,
  reset_editor_data: (state) => state.reset_editor_data,
  sdk_carousel_new_id: (state) => state.sdk_carousel_new_id,
  carousel_previous_data: (state) => state.carousel_previous_data,
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
}
